import {
  isManualRequired,
  validateValueFormat,
} from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.utils';
import _ from 'lodash';
import { string } from 'yup';

import { FieldType } from 'constants/formGenerator';

import {
  FORMAT_VALIDATED_VALUE_TYPES,
  VALUE_TYPE_TO_FIELD_TYPE_MAP,
  VALUE_TYPE_TO_INPUT_TYPE_MAP,
} from './ApplicationCustomFields.constants';

export const buildYupSchemaForDefinition = definition => {
  const isRequired = isManualRequired(definition);
  const hasFormatValidation = FORMAT_VALIDATED_VALUE_TYPES.includes(definition.valueType);

  const schema = string()
    .nullable()
    .transform(value => (_.isNil(value) || value === '' ? null : value));

  const withRequired = isRequired ? schema.required('required') : schema;

  const withFormat = hasFormatValidation
    ? withRequired.test('format', 'format', function testFormat(value) {
        if (_.isNil(value) || value === '') {
          return true;
        }

        const errorMessage = validateValueFormat({ valueType: definition.valueType, value });

        return _.isNil(errorMessage) || this.createError({ message: errorMessage });
      })
    : withRequired;

  return () => withFormat;
};

export const mapDefinitionToFieldType = definition =>
  VALUE_TYPE_TO_FIELD_TYPE_MAP[definition.valueType] ?? FieldType.INPUT;

export const getDefinitionInputType = definition =>
  VALUE_TYPE_TO_INPUT_TYPE_MAP[definition.valueType] ?? null;
